// extracted by mini-css-extract-plugin
export default {"side-title-container":"SPQozp","sideTitleContainer":"SPQozp","side-title-heading":"qo3PSW","sideTitleHeading":"qo3PSW","side-subtitle":"LBn0jf","sideSubtitle":"LBn0jf"};